import React, { useContext } from 'react';
import { MdFingerprint } from 'react-icons/md';
import { ThemeContext } from 'styled-components';
import LoginContext from '../../context/loginContext';
import useScreenResolution from '../../hooks/useScreenResolution';
import { useConsent } from '../../thirdParty/consent/ConsentProvider';
import { isMobile } from '../../utils/screenResolution';
import StyledButton from '../Buttons/StyledButton';
import { CookiePrefButtonDiv } from '../Div/StyledDiv';
import MyTooltip from '../Tooltip/MyTooltip';

interface IConsentSettingsButton {
    forcePreferences?: boolean; // immer die Detail-Ansicht öffnen
    isInProfilSafetyScreen?: boolean; // Button und kein Icon
}

export default function ConsentSettingsButton(props: IConsentSettingsButton) {
    const { ready, showBanner, managerName } = useConsent();
    const { state } = useContext(LoginContext);
    const themeContext = useContext(ThemeContext);
    const screenSize = useScreenResolution();

    if (!ready) return null;

    let forcePrefScreen = true;

    if (props.forcePreferences) {
        forcePrefScreen = props.forcePreferences;
    }

    const openPreferences = () => {
        // Usercentrics → Second Layer
        if (managerName === 'usercentrics' && (window as any).UC_UI?.showSecondLayer) {
            (window as any).UC_UI.showSecondLayer();
            return;
        }
        // consentmanager.de → Advanced Screen
        if (managerName === 'consentmanagerde' && (window as any).__cmp) {
            (window as any).__cmp('showScreenAdvanced');
            return;
        }
        // Fallback: auf das vom Backend konfigurierte Verhalten
        showBanner();
    };

    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (forcePrefScreen) {
            openPreferences();
        } else {
            showBanner();
        }
    };

    // return (
    //     <Button variant="link" onClick={onClick}>
    //         Cookie-Einstellungen
    //     </Button>
    // );

    const showButton = () => {
        if (isMobile(screenSize.width) && state.isLoggedIn) {
            return false; // Im eingeloggten Zustand auf einem Mobil Gerät sind die Cookie Einstellungen im User Menue unter 'Sicherheitseinstellungen'
        } else {
            return true;
        }
    };

    return props.isInProfilSafetyScreen ? (
        <StyledButton variant="secondary" onClick={onClick} marginTop="20px" marginBottom="20px">
            Cookie-Einstellungen
        </StyledButton>
    ) : (
        <CookiePrefButtonDiv
            onClick={onClick}
            data-id="cookiePrefButton"
            style={{ display: showButton() ? 'block' : 'none' }}
        >
            <MyTooltip
                id="cookiePrefTooltip"
                text="Cookie-Einstellungen"
                placement="top"
                iconDiv={true}
                divWidth="35px"
                marginLeft="0"
                marginRight="auto"
                icon={
                    <MdFingerprint
                        size={themeContext.icon.size}
                        color={state.isLoggedIn ? 'white' : themeContext.icon.default.color}
                        style={{ marginTop: 2 }}
                    />
                }
            ></MyTooltip>
        </CookiePrefButtonDiv>
    );
}
